import React from "react";

import { FilesProvider } from "../../../context/domain/files/FilesContext";
import UploadMedia from "../../../pages/files/UploadMedia";
import ProjectFilesFolders from "./ProjectFilesFolders";
import { useProjectPageContext } from "./ProjectPageContext";

/**
 * Render the project documents tab with Upload Media and curated Egnyte links.
 *
 * Kept mounted by ProjectPage keep-alive; folder data lives in context so tab
 * switches do not re-fetch Egnyte.
 *
 * @returns {JSX.Element}
 */
const ProjectDocuments = () => {
  const { project, placeholderContent } = useProjectPageContext();
  const { documents } = placeholderContent;

  return (
    <div className="space-y-2">
      <FilesProvider>
        <section className="rounded-xl border border-gray-200 bg-white px-4 py-2 shadow-sm shadow-primary-900/5">
          <UploadMedia
            initialProject={project.id}
            title={documents.uploadTitle}
          />
        </section>
      </FilesProvider>

      <ProjectFilesFolders />
    </div>
  );
};

export default ProjectDocuments;
